import type { InteriorOption } from '../types';

export const interiorOptions: InteriorOption[] = [
  { id: 'black-nappa', name: '블랙 나파 가죽', seatColor: '#1c1d21', trimColor: '#0f1013', price: 0 },
  { id: 'sand-beige', name: '샌드 베이지', seatColor: '#d8c6a5', trimColor: '#3b3229', price: 800000 },
  { id: 'burgundy-red', name: '버건디 레드', seatColor: '#7a1a22', trimColor: '#141416', price: 1200000 },
  { id: 'cognac-brown', name: '코냑 브라운', seatColor: '#8a5a2e', trimColor: '#241d18', price: 1200000 },
];
